import { Link } from "react-router-dom";
import { Star, ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import CTABanner from "../components/CTABanner";
import { useSEO } from "../hooks/useSEO";
import { avis, avisNote } from "../data/avis";

export default function Avis() {
  useSEO({
    title: "Avis clients — Embèk Group, jardinage et entretien des espaces verts",
    description:
      "Découvrez les avis de nos clients sur l'entretien de jardins, la taille de haies et l'aménagement paysager réalisés par Embèk Group.",
  });

  return (
    <>
      <PageHeader
        eyebrow="Avis clients"
        title="La satisfaction de nos clients"
        description="Travail soigné, ponctualité, écoute : ce que disent (nos futurs) clients d'Embèk Group."
      />

      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {avis.map((a, i) => (
              <Reveal key={a.nom} delay={(i % 3) * 0.08} className="h-full">
                <figure
                  className="h-full flex flex-col bg-white rounded-3xl border border-forest/10 p-8 shadow-sm hover:shadow-lg hover:shadow-forest/10 transition-shadow"
                  data-testid={`avis-card-${i}`}
                >
                  <div className="flex gap-1 text-[#D9A441]" aria-label="5 étoiles">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={15} fill="currentColor" strokeWidth={0} data-testid="avis-star" />
                    ))}
                  </div>
                  <blockquote className="mt-4 flex-1 font-serif italic text-lg text-forest leading-relaxed">
                    « {a.texte} »
                  </blockquote>
                  <figcaption className="mt-6 flex items-center gap-3">
                    <span className="w-10 h-10 rounded-full bg-forest/8 text-forest font-serif text-lg flex items-center justify-center">
                      {a.nom.charAt(0)}
                    </span>
                    <span className="text-sm font-semibold text-coal-muted">{a.nom}</span>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-10 text-center">
            <p className="inline-block px-5 py-2.5 rounded-full bg-sand-mid text-[12px] text-coal-muted italic" data-testid="avis-demo-note">
              {avisNote}
            </p>
          </Reveal>
        </div>
      </section>

      <CTABanner />
    </>
  );
}
